import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { UiPhoneInputComponent } from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

@Component({
  selector: 'app-phone-input-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiPhoneInputComponent, AppExampleSectionComponent],
  templateUrl: './phone-input-doc.component.html',
  styleUrl: './phone-input-doc.component.scss',
})
export class PhoneInputDocComponent {
  protected readonly callingCode = signal('+52');
  protected readonly phoneNumber = signal('');
  protected readonly isInvalid = signal(false);
  protected readonly showErrorMsg = signal(true);

  protected toggleInvalid(): void {
    this.isInvalid.update((v) => !v);
  }

  protected toggleErrorMsg(): void {
    this.showErrorMsg.update((v) => !v);
  }
}
